import React, {memo} from "react";
import * as S from "./GoTribeReviewFooterStyle";
import SvgIconElementUI from '../../ResultsPage/RydeAssuredBanner/SvgIconElement/SvgIconElementUI';
 
const GoTribeReviewFooter = ({
  margin = null,
  messageText = null,
  iconUrl = "",
  iconColor = "",
}) => {
  return (
    <S.GoTribeReviewFooterWrapperOuterWrapper margin={margin}>
      <S.GoTribeReviewFooterWrapper>
        <S.GoTribeTextWrapper iconColor={iconColor}>
          <S.GoTribeImageWrapper src={iconUrl} />
        </S.GoTribeTextWrapper>
        <S.GoTribeReviewFooterText dangerouslySetInnerHTML={{__html: messageText}} />
      </S.GoTribeReviewFooterWrapper>
    </S.GoTribeReviewFooterWrapperOuterWrapper>
  );
};
 
export default memo(GoTribeReviewFooter);